export const CLIENT_SEARCH_OFFSET = 10
export const PLATFORM = {
  WEB: 'WEB',
  MOBILE: 'MOBILE'
}

export enum SEND_MESSAGE_ALERT_TYPE {
  OPTIN = 'OPTIN',
  BLOCK_CONTACT = 'BLOCK_CONTACT'
}

export type SEND_MESSAGE_ALERT_BODY = {
  message: string
}

export const SEND_MESSAGE_ALERT: Record<SEND_MESSAGE_ALERT_TYPE, SEND_MESSAGE_ALERT_BODY> = {
  OPTIN: {
    message:
      'ATENÇÃO: Consta no cadastro deste cliente que ele não autoriza ser contactado. De acordo com a LGPD, você não\n' +
      'deveria iniciar uma conversa. Tem certeza que deseja continuar?'
  },
  BLOCK_CONTACT: {
    message: 'Este contato está bloqueado, deseja desbloquear e continuar?'
  }
}

export const SOURCE_TYPES: Record<string, { name: string; description: string }> = {
  DEFAULT: {
    name: 'DEFAULT',
    description: ''
  },
  AD: {
    name: 'AD',
    description: 'Enviada via anúncio'
  },
  POST: {
    name: 'POST',
    description: 'Enviada via publicação'
  },
  ECHO: {
    name: 'ECHO',
    description: 'Enviada via WhatsApp Business App'
  }
}
